import { Dayjs } from "dayjs"

export enum DebtPaymentPlanStatus {
  ACTIVE = "active",
  PENDING = "pending",
  CANCELLED = "cancelled",
  STOPPING = "stopping",
}

export interface IDebtPaymentPlan {
  status: DebtPaymentPlanStatus
  id: number
  planLengthInMonths: number
  remainingPaymentMonths: number
  createdAt: Dayjs
  totalDebt?: number
  debtMonthlyPayment?: number
  remainingBalance?: number
  paymentDay?: number
  lastPaymentDate?: Dayjs
  type?: string

  readonly isActive: boolean
}
